import { useEffect } from "react";
import { useSession } from "@clerk/clerk-react";
import { setByokToken, setByokTokenProvider } from "../api/client";

/**
 * Wires the current Clerk session into the BYOK transport.
 *
 * Registers a provider that fetches a *fresh* token on every request rather
 * than caching one at mount. Clerk session tokens expire (~60s TTL); a cached
 * token went stale, so "Testar"/"Remover" clicked minutes after page load
 * 401'd. session.getToken() returns a cached token while valid and refreshes
 * it transparently when expired.
 */
export function useSyncByokToken(): void {
  const { session } = useSession();

  useEffect(() => {
    if (!session) {
      setByokTokenProvider(null);
      setByokToken(null);
      return;
    }

    setByokTokenProvider(() => session.getToken());

    // Warm the static fallback so the first request has a token even if the
    // provider call is in flight.
    let cancelled = false;
    void session.getToken().then((token) => {
      if (!cancelled) setByokToken(token);
    });

    return () => {
      cancelled = true;
      setByokTokenProvider(null);
    };
  }, [session]);
}
